import orderInstance from '../instance'

const getBeeperConfigs = (module) => {
	return orderInstance.get(`/beeperConfigs?module=${module}`)
}

export default getBeeperConfigs
